<template>
<div v-loading="loading">
  <el-row class="title-bar">
    <el-col class="btn-group-right">
      <el-button size="small" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
      <el-button type="primary" size="small" @click="excuteDeviceCheck" :disabled="excuteCheckBtn">수동점검수행</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"/>
    </el-col>
  </el-row>
  <div class="list-info">
    <div class="select vertical-center-box">
      <span class="tit">
        점검 일시
      </span>
      <el-date-picker class="mr-r4" style="width:150px;" v-model="selectedCheckMonth" type="month" format="yyyy년 MM월" :clearable="false" />
      <el-select style="width:100px;" v-model="selectedCheckDate" placeholder="날짜를 선택해주세요.">
        <el-option v-for="item in checkDateList" :key="item.DAY" :label="item.DAY + '일'" :value="item.DAY" />
      </el-select>
    </div>
    <ul class="lists">
      <li v-for="template in keys(checkChangeTemplate)" :key="template">
        <span class="tit">{{checkChangeTemplate[template]}} 변경 :</span>
        <span class="high" v-if="checkCountData">{{checkCountData[template+'Cnt']}}건</span>
        <span class="high" v-else>0건</span>
      </li>
    </ul>
  </div>
  <el-row>
    <el-table-wrapper border :data="tableData" ref="tempTable" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" @selection-change="handleSelectionChange" style="width:100%;"
    :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
      <template slot-scope="scope" slot="check-change">
          <span v-if="scope.row[scope.column.property] === 0" @click="showChangeHistPopup(scope.column.property, scope.row)">
            <el-tooltip effect="dark" placement="bottom">
              <span slot="content">
                정상
              </span>
              <i class="fas fa-circle text-mini state-normal c-pointer"></i>
            </el-tooltip>
          </span>
          <span v-else-if="scope.row[scope.column.property] === 1" @click="showChangeHistPopup(scope.column.property, scope.row)">
            <el-tooltip effect="dark" placement="bottom">
              <span slot="content">
                변경
              </span>
              <i class="fas fa-circle text-mini state-abnormal c-pointer"></i>
            </el-tooltip>
          </span>
          <span v-else>
            <el-tooltip effect="dark" placement="bottom">
              <span slot="content">
                미수집
              </span>
              <i class="fas fa-circle text-mini state-none"></i>
            </el-tooltip>
          </span>
        </template>
      <template slot-scope="scope" slot="detail-info">
          <span @click="showDetailInfoPopup(scope.row)"><i class="far fa-search-plus c-pointer"></i></span>
      </template>
      <template #obj-name-slot="scope">
        <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
        <span v-else>-</span>
      </template>
    </el-table-wrapper>
  </el-row>
  <w-change-hist-popup ref="changeHistPopup" :popup-hist-info="popupHistInfo" />
  <w-change-info-popup ref="changeInfoPopup" :popup-info="popupInfo" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { map, isNil, keys, clone, isEmpty } from 'lodash';
import { getDateToString } from '@/utils/date';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import WChangeHistPopup from './popup/ChangeHistPopup';
import WChangeInfoPopup from './popup/ChangeInfoPopup';

export default {
  name: 'WDeviceRegularCheckView',
  components: {
    WChangeHistPopup,
    WChangeInfoPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      columnDefault,
      tableTotal: 0,
      checkChangeTemplate: {
        total: '전체',
        device: '장비',
        interface: '인터페이스',
        config: '컨피그',
        hardware: '하드웨어',
        routing: '라우팅',
        vlan: 'VLAN',
        stp: 'STP',
        ip: 'IP',
      },
      loading: false,
      selectedCheckMonth: null,
      selectedCheckDate: null,
      checkDateList: [],
      tableData: [],
      checkCountData: null,
      showSearchTool: false,
      columns: [
        {
          type: 'selection',
        },
        {
          prop: 'objName',
          label: '장비명',
          sortable: true,
          searchable: true,
          scopedSlot: 'obj-name-slot',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipaddress',
          label: 'IP',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objtypeName',
          label: '장비종류',
          remoteProp: 'ot.objtype_name',
          sortable: true,
          searchable: true,
          width: 120,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'deviceFlag',
          label: '장비변경',
          width: 115,
          scopedSlot: 'check-change',
          sortable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'interfaceFlag',
          label: '인터페이스변경',
          width: 115,
          scopedSlot: 'check-change',
          sortable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'configFlag',
          label: '컨피그변경',
          width: 115,
          scopedSlot: 'check-change',
          sortable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'hardwareFlag',
          label: '하드웨어변경',
          width: 115,
          scopedSlot: 'check-change',
          sortable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'routingFlag',
          label: '라우팅변경',
          width: 115,
          scopedSlot: 'check-change',
          sortable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'vlanFlag',
          label: 'VLAN변경',
          width: 115,
          scopedSlot: 'check-change',
          sortable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'stpFlag',
          label: 'STP변경',
          width: 100,
          scopedSlot: 'check-change',
          sortable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'ipFlag',
          label: 'IP변경',
          width: 100,
          scopedSlot: 'check-change',
          sortable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'checkDatetime',
          label: '전체 점검일시',
          width: 150,
          sortable: true,
          searchable: true,
          searchType: 'date',
          formatter: this.convertCheckDatetime,
        },
        {
          label: '상세보기',
          width: 70,
          scopedSlot: 'detail-info',
          headerAlign: 'center',
          align: 'center',
        },
      ],
      params: {
        managegroupIds: null,
      },
      popupInfo: {},
      popupHistInfo: {},
      // regularCheckDetailPopupInfo: {},
      selectedObjIds: [],
    };
  },
  computed: {
    excuteCheckBtn() {
      return this.selectedObjIds.length === 0;
    },
    ...mapGetters(['selectedObjDefineIds', 'selectedNode', 'selectedObjDefineIdsForPhysical']),
    managegroupIds() {
      return this.selectedNode ? this.selectedNode.childManagegroupIds : [];
    },
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        this.params.managegroupIds = this.selectedNode.childManagegroupIds;
        if (this.$refs.tempTable === undefined) {
          this.$nextTick(() => {
            this.$refs.tempTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.tempTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    selectedObjDefineIdsForPhysical() {
      this.loadStore();
    },
    activeTab: {
      handler() {
        this.loadStore();
      },
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
    selectedCheckMonth: {
      handler() {
        this.loadDays();
      },
    },
    selectedCheckDate: {
      handler() {
        this.loadCheckList();
      },
    },
  },
  methods: {
    keys,
    /**
     * 연/월 콤보박스 설정
     * @author kimjy
     */
    loadStore() {
      if (this.active && this.activeTab === this.$options.name) {
        this.selectedCheckMonth = moment().startOf('month').toDate();
      }
    },
    /**
     * 선택된 연/월에 대한 날짜 조회 (점검이력이 있는 날짜만 조회)
     * @author kimjy
     */
    loadDays() {
      const params = {
        managegroupIds: this.managegroupIds,
        startDatetime: this.selectedCheckMonth.getTime(),
      };
      if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
        params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
      }
      if (!isEmpty(this.selectedObjDefineIds)) {
        params.objDefineIds = this.selectedObjDefineIds;
      }
      netdeviceInfoAPI.getNetdeviceRegularCheckDayList(params).then((response) => {
        if (response.data.success) {
          if (response.data.data.length > 0) {
            this.checkDateList = response.data.data;
            if (this.checkDateList[0].DAY === this.selectedCheckDate) {
              this.loadCheckList();
            } else {
              this.selectedCheckDate = this.checkDateList[0].DAY;
            }
          } else {
            this.checkDateList = [];
            this.selectedCheckDate = null;
            this.checkCountData = null;
            this.tableData = [];
          }
        } else {
          this.showLoadFailMsg();
        }
      }).catch(() => {
        this.showLoadFailMsg();
      });
    },
    /**
     * 선택된 날짜에 대한 점검 이력 조회
     * @author kimjy
     */
    loadCheckList() {
      if (!isNil(this.selectedCheckDate)) {
        const checkDatetime = moment(this.selectedCheckMonth).date(this.selectedCheckDate).toDate();
        const tableParams = this.$refs.tempTable.getParameter();
        const params = {
          managegroupIds: this.managegroupIds,
          checkDatetime: checkDatetime.getTime(),
          ...tableParams,
          treeType: this.treeType,
          managetypeId: this.selectedNode.managetypeId,
          objCompanyId: this.selectedNode.objCompanyId,
        };
        if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
          params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
        }
        if (!isEmpty(this.selectedObjDefineIds)) {
          params.objDefineIds = this.selectedObjDefineIds;
        }
        this.loading = true;
        netdeviceInfoAPI.getNetdeviceRegularCheckList(params).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.tableData = result.list.data;
            this.tableTotal = result.list.total;
            this.checkCountData = result.count;
          } else {
            this.showLoadFailMsg();
          }
        }).catch(() => {
          this.showLoadFailMsg();
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    /**
     * 정기 점검 조회 실패 시 메시지 제공
     * @author Ju
     * @return {[type]} [description]
     */
    showLoadFailMsg() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '정기 점검 정보', false));
    },
    /**
     * 장비 점검 현황 엑셀 출력
     * @author kimjy
     */
    exportExcel() {
      const excelParams = clone(this.params);
      excelParams.checkDatetime = moment(this.selectedCheckMonth).date(this.selectedCheckDate).toDate();
      const tableParams = this.$refs.tempTable.getParameter();
      const params = {
        ...excelParams,
        ...tableParams,
        treeType: this.treeType,
        managetypeId: this.selectedNode.managetypeId,
        objCompanyId: this.selectedNode.objCompanyId,
      };
      if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
        params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
      }
      if (!isEmpty(this.selectedObjDefineIds)) {
        params.objDefineIds = this.selectedObjDefineIds;
      }
      netdeviceInfoAPI.exportNetdeviceRegularCheckList(params);
    },
    handleSelectionChange(selectDeviceList) {
      this.selectedObjIds = map(selectDeviceList, 'objId');
    },
    /**
     * 수동 점검 수행
     * @author kimjy
     */
    excuteDeviceCheck() {
      const objIds = this.selectedObjIds;

      netdeviceInfoAPI
        .excuteNetdeviceCheck({
          objIds,
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('수행', '정기 점검', false));
        })
        .finally(() => {
          this.$notify({
            title: '정기 점검 수행',
            customClass: 'center',
            message: '정기 점검 수행을 시작하였습니다. 수분의 시간이 소요됩니다.',
            duration: 2000,
          });
        });
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author kimjy
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 테이블 데이터 날짜 포맷 확인
     * @author kimjy
     */
    convertCheckDatetime(row, column, value) {
      if (isNil(value)) {
        return '점검 진행중';
      }
      return getDateToString(value);
    },
    /**
     * 각 타입별 변경 정보 팝업 Open
     * @author kimjy
     * @param  {[type]} popupType 클릭한 컬럼의 타입 (device, interface, hardware 등)
     * @param  {[type]} rowData   해당 Row의 Data
     */
    showChangeHistPopup(popupType, rowData) {
      const key = popupType.substr(0, popupType.length - 4);
      const checkDatetime = moment(this.selectedCheckMonth).date(this.selectedCheckDate).toDate();

      const popupInfo = {
        key: key.toUpperCase(),
        popupTitle: this.checkChangeTemplate[key],
        objId: rowData.objId,
        histSeq: rowData.histSeq,
        targetCheckDatetime: rowData.checkDatetime,
        objCompanyName: rowData.objCompanyName,
        checkDatetime,
      };

      if (rowData[popupType] === 1) {
        this.$refs.changeHistPopup.open(); // 변경 팝업
        this.popupHistInfo = popupInfo;
      } else {
        popupInfo.popupWidth = key.toUpperCase() === 'INTERFACE' ? '900px' : '600px';
        this.popupInfo = popupInfo;
        this.$refs.changeInfoPopup.open();
      }
    },
    /**
     * 점검 내용 상세 팝업 open
     * @author jeee12
     */
    showDetailInfoPopup(currentRow) {
      this.$store.dispatch('openRegularCheckDetailInfoPopup', currentRow);
    },
    onChangeTable() {
      this.loadStore();
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//list info
//url
$url : '../../../../../assets/img/';

.list-info{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  border: 1px solid #e9e9e9;
  background-color: #f1f1f1;
  margin-bottom: 10px;
  padding: 4px 18px;

  & > .select{
    padding: 4px 0;
  }
  .select > .tit{
    padding-right: 10px;
    font-size: 14px;
    letter-spacing: -1px;
  }

  .custom-input{
    margin-left: 4px;

    &:first-child{
      margin-left: 0;
    }
  }

  .lists{
    display: inline-block;
    align-items: center;
    padding: 5px 0;

    & > li{
      //margin-left: 14px;
      //padding-left: 10px;
      // background: url($url + 'dot.png') no-repeat 0 5px;
      font-weight: 500;
      display: inline;
      width: 40%;

      &:first-child{
        //margin-left: 0;
        //padding-left: 0;
      }
    }
    & > li > .tit{
      display: inline-block;
      padding-right: 4px;
      font-size: 13px;
      letter-spacing: -1px;
    }
    .high{
      color: #1c768d;
      margin-right: 14px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/DeviceRegularCheckView.vue